import { ApplicationConfig, LOCALE_ID, importProvidersFrom } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AngularUiFormConfig } from '@pedix-workspace/angular-ui-form';
import { provideFirebase } from '@pedix-workspace/angular-firebase';
import { getFirebaseApp, getFirebaseFirestore, getFirebaseFunctions } from './firebase/clients';
import { provideToastr } from 'ngx-toastr';
import { FormsModule } from '@angular/forms';
import { AppCurrencyFormatService } from './features/shared/app-currency-format.service';
import { CurrencyFormatService } from '@pedix-workspace/pedixapp-shared-pipes';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';
import {
  PreloadAllModules,
  provideRouter,
  withHashLocation,
  withInMemoryScrolling,
  withPreloading,
} from '@angular/router';
import { appSubscriptionWizardRoutes } from './app-subscription-wizard.routes';
import { STRIPE_PUBLISHABLE_KEY, provideNgxStripe } from 'ngx-stripe';
import { environment } from '../environments/environment';
import { provideTransloco } from '@jsverse/transloco';
import { TranslocoHttpLoader } from './transloco/transloco-http-loader.module';

class CustomAngularUiFormConfig extends AngularUiFormConfig {
  getCurrencySymbol() {
    return '$';
  }

  getValidationRequiredText() {
    return 'Requerido';
  }
}

export const appSubscriptionWizardConfig: ApplicationConfig = {
  providers: [
    provideFirebase({
      app: getFirebaseApp,
      firestore: getFirebaseFirestore,
      functions: getFirebaseFunctions,
    }),
    importProvidersFrom(FormsModule),
    { provide: LOCALE_ID, useValue: 'es-Ar' },
    { provide: APP_BASE_HREF, useValue: '!' },
    { provide: AngularUiFormConfig, useClass: CustomAngularUiFormConfig },
    {
      provide: AppCurrencyFormatService,
      useClass: AppCurrencyFormatService,
    },
    {
      provide: CurrencyFormatService,
      useExisting: AppCurrencyFormatService,
    },
    { provide: STRIPE_PUBLISHABLE_KEY, useValue: environment.stripePublishableKey },
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(
      appSubscriptionWizardRoutes,
      withHashLocation(),
      withPreloading(PreloadAllModules),
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }),
    ),
    provideTransloco({
      config: {
        availableLangs: ['esMx', 'esAr'],
        defaultLang: 'esAr',
        // Remove this option if your application
        // doesn't support changing language in runtime.
        reRenderOnLangChange: true,
      },
      loader: TranslocoHttpLoader,
    }),
    provideNgxStripe(environment.stripePublishableKey),
    provideToastr({
      timeOut: 6000,
      positionClass: 'toast-top-center',
      preventDuplicates: true,
      closeButton: true,
    }),
  ],
};
